import { IBaseAction } from '@bimser/core';
import { fork, take, call, put, takeLatest } from 'redux-saga/effects';
import {
	DmDataFactoryFromJS,
	DmViewerActions,
	DmViewerEntities,
	GenerateDmModel,
	IDmData,
	ServiceList,
	panelType
} from '@bimser/common';
import { setRecentFilesDataAction, setRecentFilesLoadingAction } from '../../actions';
import * as ActionTypes from '../../actions/actionTypes';
import * as commonActionTypes from '../../../../common/actions/actionTypes';
import { WebInterfaceAction } from '../../../../common/entities';
import { openAdvancedViewer } from '../../../dm/components/viewer/sagas/openViewer';
import { setDmParametersAction } from '../../../dm/actions';
import { List } from 'immutable';
import { DmParametersFactoryFromJS } from '../../../dm/entities/models/IDmParameters';
import { findMessage } from '@bimser/components';
import { addDmObjectAction } from '../../../dm/actions/object/addDmObjectAction';
import { updateRecentFiles } from '../../../dm/actions/panel/updateRecentFiles';

export default function* watchRecentFilesManager() {
	while (true) {
		const action: IBaseAction<WebInterfaceAction> = yield take(
			(_action: IBaseAction<WebInterfaceAction>) => {
				if (
					_action.type === commonActionTypes.INITIALIZE_PANEL_MANAGER &&
					_action.payload?.panelType === panelType.startupLayout
				) {
					return true;
				}
			}
		);

		yield fork(recentFilesManager, action);
	}
}

const whiteList = [ActionTypes.ON_CLICK_RECENT_FILE_TRANSACTION];

function* recentFilesManager(action: IBaseAction<WebInterfaceAction>) {
	yield call(getRecentFiles);
	yield fork(handleGetDmParameters);

	yield takeLatest(
		(dashboardAction: IBaseAction<WebInterfaceAction>) =>
			whiteList.includes(dashboardAction.type) &&
			dashboardAction.payload?.panelId === action.payload?.panelId,
		function* (dashboardAction: IBaseAction<WebInterfaceAction>) {
			switch (dashboardAction.type) {
				case ActionTypes.ON_CLICK_RECENT_FILE_TRANSACTION: {
					yield call(onClickRecentFile, dashboardAction.payload);
					break;
				}
			}
		}
	);
}

export function* handleGetDmParameters() {
	try {
		const response = yield ServiceList.dm.DocumentManagement.Explorer.GetParameters.call();
		if (response) {
			yield put(setDmParametersAction(response));
			yield put(
				DmViewerActions.setViewersConfigAction(
					List(
						response.viewersConfig?.map(v =>
							DmViewerEntities.ViewerConfigItemFactoryFromJS(v)
						)
					)
				)
			);
		}
	} catch (error) {}
}

export function* getRecentFiles() {
	yield put(setRecentFilesLoadingAction(true));
	const recentFiles: Array<any> =
		yield ServiceList.dm.DocumentManagement.Explorer.GetRecentObjects.call(
			undefined,
			undefined,
			true
		);

	if (recentFiles?.length) {
		const data: Array<IDmData> = recentFiles.map(dmData => GenerateDmModel(dmData).toJS());
		yield call(afterGetRecentFiles, data);
		yield put(setRecentFilesDataAction(data.slice(0, 5)));
	}
	yield put(setRecentFilesLoadingAction(false));
}

function* onClickRecentFile(payload: WebInterfaceAction) {
	yield call(openAdvancedViewer, {
		dmData: payload.data,
		openedFrom: 'recent',
		checkExistance: true,
		panelSize: 3,
		parentPanel: {
			panelGuid: payload.panelId,
			panelType: payload.panelType
		}
	});
}

function* afterGetRecentFiles(data: Array<IDmData>) {
	const ids = data.map(item => item.id);

	const recentFile = DmDataFactoryFromJS({
		id: '#Recent',
		name: findMessage.get('100861'),
		children: ids,
		childsFetched: true
	});

	yield put(
		addDmObjectAction({
			parentId: '#Recent',
			parent: recentFile,
			objects: data.map(item => DmDataFactoryFromJS(item))
		})
	);

	yield put(
		updateRecentFiles({
			data: List(ids)
		})
	);
}
